module.exports = __webpack_public_path__ + "static/media/lucas-benjamin.ddf326ec.jpg";